import { c as _c } from "react/compiler-runtime";
export interface TabTitleWithCountProps {
  label: string;
  count?: number;
}

// Tab label with an optional count badge. Designed to render inside a HeroUI `Tab`'s
// `title` prop — the badge's selected styling keys off the tab's `group-data-[selected]`.
export const TabTitleWithCount = t0 => {
  const $ = _c(5);
  const {
    label,
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = count !== undefined && <span className="inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-default-200 px-1 font-medium text-default-600 text-tiny group-data-[selected=true]:bg-primary group-data-[selected=true]:text-primary-foreground">{count}</span>;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== t1) {
    t2 = <span className="inline-flex items-center gap-1.5">{label}{t1}</span>;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};